import { defineMessages } from 'react-intl';

export default defineMessages({
  label: {
    id: 'app.components.CreateShiftButton.label',
    defaultMessage: 'Create shift',
  },
  shiftCreationFailed: {
    id: 'app.components.CreateShiftButton.shiftCreationFailed',
    defaultMessage: 'Failed to create the shift.',
  },
  shiftCreationSucceeded: {
    id: 'app.components.CreateShiftButton.shiftCreationSucceeded',
    defaultMessage: 'Shift successfully created.',
  },
});
